// material ui
import Stack from "@mui/material/Stack";

// project import
import CircularWithPath from "./@extended/progress/CircularWithPath";
import { Box } from "@mui/material";

// ==============================|| LOADER - CIRCULAR ||============================== //

// export default function CircularLoader() {
//   return (
//     <Stack alignItems="center" justifyContent="center" sx={{ height: "100%" }}>
//       <CircularWithPath />
//     </Stack>
//   );
// }
export default function CircularLoader() {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Disable user interaction and make background semi-transparent
        zIndex: 1300, // High zIndex to overlay everything
      }}
    >
      <Stack alignItems="center" justifyContent="center">
        <CircularWithPath />
      </Stack>
    </Box>
  );
}
